export default __webpack_public_path__ + "static/media/logo.40a86811.png";